(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cita-about"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('cita-ab--vis');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll(
    '.cita-ab__prose, .cita-ab__split-ct, .cita-ab__memorial-photos, .cita-ab__memorial-name, .cita-ab__ms, .cita-ab__legacy-ct'
  ).forEach(function(el) {
    el.classList.add('cita-ab--fade');
    obs.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-collection-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {

    // Carousel dot sync
    document.querySelectorAll('.cita-col__carousel').forEach(function(carousel) {
      var id = carousel.dataset.productId;
      var dotsEl = document.querySelector('[data-dots="' + id + '"]');
      if (!dotsEl) return;
      var dots = dotsEl.querySelectorAll('.cita-col__dot');
      carousel.addEventListener('scroll', function() {
        var i = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        dots.forEach(function(d, j) { d.classList.toggle('on', j === i); });
      }, { passive: true });
    });

    // Scroll reveal
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.07 });
      document.querySelectorAll('.cita-col__card.cita-reveal').forEach(function(el) {
        obs.observe(el);
      });
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-contact"] && !Shopify.designMode) return;
  try {
    
(function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cita-ct--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.cita-ct__shortcut, .cita-ct__card, .cita-ct__left, .cita-ct__map-header, .cita-ct__signoff-ct').forEach(function(el) {
    el.classList.add('cita-ct--fade');
    observer.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-product-bundle"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('cita-bundle-form');
    if (!form) return;

    var mediaEl = document.getElementById('cita-media-data');
    var variantsEl = document.getElementById('cita-variants-data');
    if (!mediaEl || !variantsEl) return;

    var mediaData = JSON.parse(mediaEl.textContent);
    var variantsData = JSON.parse(variantsEl.textContent);
    var currentIndex = 0;

    var mainImg = document.getElementById('cita-main-img');
    var thumbs = document.querySelectorAll('.cita-pp__thumb');
    var counter = document.getElementById('cita-img-index');

    function setImage(idx) {
      if (!mediaData[idx]) return;
      currentIndex = idx;
      if (mainImg) {
        mainImg.style.opacity = '0.6';
        mainImg.src = mediaData[idx].src;
        mainImg.alt = mediaData[idx].alt || '';
        mainImg.onload = function() { mainImg.style.opacity = '1'; };
      }
      thumbs.forEach(function(t, i) { t.classList.toggle('active', i === idx); });
      if (counter) counter.textContent = idx + 1;
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { setImage(i); });
      thumb.addEventListener('keydown', function(e) { if (e.key === 'Enter') setImage(i); });
    });

    var prevBtn = document.getElementById('cita-prev');
    var nextBtn = document.getElementById('cita-next');
    if (prevBtn) prevBtn.addEventListener('click', function() { setImage((currentIndex - 1 + mediaData.length) % mediaData.length); });
    if (nextBtn) nextBtn.addEventListener('click', function() { setImage((currentIndex + 1) % mediaData.length); });

    // --- Quantity ---
    var qtyInput = document.getElementById('cita-qty-input');
    var qtyMinus = document.getElementById('cita-qty-minus');
    var qtyPlus = document.getElementById('cita-qty-plus');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        if (v < 10) qtyInput.value = v + 1;
      });
    }

    // --- Variant / Swatches (multi-option) ---
    var variantIdInput = document.getElementById('cita-variant-id');
    var priceEl = document.getElementById('cita-price-current');
    var compareEl = document.getElementById('cita-price-compare');
    var afterpayEl = document.getElementById('cita-afterpay-amt');
    var stickyPriceEl = document.getElementById('cita-sticky-price');
    var swatches = document.querySelectorAll('.cita-pp__swatch');

    // Seed selected options from Liquid-rendered values (set in inline <script> above)
    var selectedOptions = window._citaBundleSelectedOptions || {};

    function formatMoney(cents) {
      return (window.Shopify && window.Shopify.formatMoney)
        ? window.Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    }

    function selectVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if (afterpayEl) afterpayEl.textContent = formatMoney(Math.floor(variant.price / 4));
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
      var savings = (variant.compare_at_price && variant.compare_at_price > variant.price)
        ? variant.compare_at_price - variant.price : 0;
      ['cita-savings-badge', 'cita-savings-trust', 'cita-savings-atc'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.textContent = savings > 0 ? formatMoney(savings) : '';
      });
      if (variant.featured_image && mediaData.length > 0) {
        var imgIdx = mediaData.findIndex(function(m) { return m.id === variant.featured_image.id; });
        if (imgIdx > -1) setImage(imgIdx);
      }
    }

    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var value = swatch.dataset.value;
        var optionPos = parseInt(swatch.dataset.optionPosition) || 1;

        selectedOptions[optionPos] = value;

        // Deactivate only within this option group
        document.querySelectorAll('.cita-pp__swatch[data-option-position="' + optionPos + '"]').forEach(function(s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');

        var labelEl = document.querySelector('.cita-pp__color-selected[data-option-position="' + optionPos + '"]');
        if (labelEl) labelEl.textContent = value;

        // Match variant where all selected options agree
        var match = variantsData.find(function(v) {
          return Object.keys(selectedOptions).every(function(pos) {
            return v['option' + pos] === selectedOptions[pos];
          });
        });
        if (match) selectVariant(match);
      });
    });

    // --- Accordions ---
    document.querySelectorAll('.cita-pp__accordion-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var accordion = trigger.closest('.cita-pp__accordion');
        if (!accordion) return;
        var isOpen = accordion.classList.contains('open');
        document.querySelectorAll('.cita-pp__accordion').forEach(function(a) { a.classList.remove('open'); });
        if (!isOpen) {
          accordion.classList.add('open');
          if (accordion.classList.contains('cita-pp__accordion--reviews')) {
            setTimeout(function() {
              if (window.jdgm && typeof window.jdgm.reInit === 'function') {
                window.jdgm.reInit();
              } else if (window.jdgm && typeof window.jdgm.pageLoad === 'function') {
                window.jdgm.pageLoad();
              }
            }, 150);
          }
        }
      });
    });

    // --- Sticky ATC (mobile) ---
    var stickyAtc = document.getElementById('cita-sticky-atc');
    var atcBtn = document.getElementById('cita-atc-btn');
    var stickyBtn = document.getElementById('cita-sticky-btn');

    if (stickyAtc && atcBtn) {
      var observer = new IntersectionObserver(function(entries) {
        stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(atcBtn);
    }

    if (stickyBtn && atcBtn) {
      stickyBtn.addEventListener('click', function() { atcBtn.click(); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-product-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cita-pp-faq__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.closest('.cita-pp-faq__item');
        if (!item) return;
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.cita-pp-faq__item').forEach(function(i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('cita-product-form');
    if (!form) return;

    // --- Media data ---
    var mediaEl = document.getElementById('cita-media-data');
    var variantsEl = document.getElementById('cita-variants-data');
    if (!mediaEl || !variantsEl) return;

    var mediaData = JSON.parse(mediaEl.textContent);
    var variantsData = JSON.parse(variantsEl.textContent);
    var currentIndex = 0;

    var mainImg = document.getElementById('cita-main-img');
    var thumbs = document.querySelectorAll('.cita-pp__thumb');
    var counter = document.getElementById('cita-img-index');

    function setImage(idx) {
      if (!mediaData[idx]) return;
      currentIndex = idx;
      if (mainImg) {
        mainImg.style.opacity = '0.6';
        mainImg.src = mediaData[idx].src;
        mainImg.alt = mediaData[idx].alt || '';
        mainImg.onload = function() { mainImg.style.opacity = '1'; };
      }
      thumbs.forEach(function(t, i) { t.classList.toggle('active', i === idx); });
      if (counter) counter.textContent = idx + 1;
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { setImage(i); });
      thumb.addEventListener('keydown', function(e) { if (e.key === 'Enter') setImage(i); });
    });

    var prevBtn = document.getElementById('cita-prev');
    var nextBtn = document.getElementById('cita-next');
    if (prevBtn) prevBtn.addEventListener('click', function() { setImage((currentIndex - 1 + mediaData.length) % mediaData.length); });
    if (nextBtn) nextBtn.addEventListener('click', function() { setImage((currentIndex + 1) % mediaData.length); });

    // --- Quantity ---
    var qtyInput = document.getElementById('cita-qty-input');
    var qtyMinus = document.getElementById('cita-qty-minus');
    var qtyPlus = document.getElementById('cita-qty-plus');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value) || 1;
        if (v < 10) qtyInput.value = v + 1;
      });
    }

    // --- Variant / Swatches ---
    var variantIdInput = document.getElementById('cita-variant-id');
    var priceEl = document.getElementById('cita-price-current');
    var compareEl = document.getElementById('cita-price-compare');
    var afterpayEl = document.getElementById('cita-afterpay-amt');
    var colorLabelEl = document.getElementById('cita-color-label');
    var stickyPriceEl = document.getElementById('cita-sticky-price');
    var swatches = document.querySelectorAll('.cita-pp__swatch');

    function formatMoney(cents) {
      return (window.Shopify && window.Shopify.formatMoney)
        ? window.Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    }

    function selectVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if (afterpayEl) afterpayEl.textContent = formatMoney(Math.floor(variant.price / 4));

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (variant.featured_image && mediaData.length > 0) {
        var imgIdx = mediaData.findIndex(function(m) { return m.id === variant.featured_image.id; });
        if (imgIdx > -1) setImage(imgIdx);
      }
    }

    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var value = swatch.dataset.value;
        var optionPos = parseInt(swatch.dataset.optionPosition) || 1;
        swatches.forEach(function(s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        if (colorLabelEl) colorLabelEl.textContent = value;

        var match = variantsData.find(function(v) {
          return v['option' + optionPos] === value;
        });
        if (match) selectVariant(match);
      });
    });

    // --- Accordions ---
    document.querySelectorAll('.cita-pp__accordion-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var accordion = trigger.closest('.cita-pp__accordion');
        if (!accordion) return;
        var isOpen = accordion.classList.contains('open');
        document.querySelectorAll('.cita-pp__accordion').forEach(function(a) { a.classList.remove('open'); });
        if (!isOpen) {
          accordion.classList.add('open');
          if (accordion.classList.contains('cita-pp__accordion--reviews')) {
            setTimeout(function() {
              if (window.jdgm && typeof window.jdgm.reInit === 'function') {
                window.jdgm.reInit();
              } else if (window.jdgm && typeof window.jdgm.pageLoad === 'function') {
                window.jdgm.pageLoad();
              }
            }, 150);
          }
        }
      });
    });

    // --- Sticky ATC (mobile) ---
    var stickyAtc = document.getElementById('cita-sticky-atc');
    var atcBtn = document.getElementById('cita-atc-btn');
    var stickyBtn = document.getElementById('cita-sticky-btn');

    if (stickyAtc && atcBtn) {
      var observer = new IntersectionObserver(function(entries) {
        stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(atcBtn);
    }

    if (stickyBtn && atcBtn) {
      stickyBtn.addEventListener('click', function() { atcBtn.click(); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-quiz-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var dataEl = document.getElementById('cita-quiz-data');
  if (!dataEl) return;
  var products = JSON.parse(dataEl.textContent);

  function showPanel(id) {
    var panels = document.querySelectorAll('#cita-quiz-section .cita-quiz__panel');
    panels.forEach(function(p) {
      p.classList.add('cita-quiz__hidden');
      p.classList.remove('cita-quiz__visible');
    });
    var target = document.getElementById('cita-quiz-' + id);
    if (!target) return;
    target.classList.remove('cita-quiz__hidden');
    requestAnimationFrame(function() {
      target.classList.add('cita-quiz__visible');
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var startBtn = document.getElementById('cita-quiz-start-btn');
    if (startBtn) startBtn.addEventListener('click', function() { showPanel('q1'); });

    document.querySelectorAll('#cita-quiz-q1 .cita-quiz__opt').forEach(function(btn) {
      btn.addEventListener('click', function() { showPanel('q2-' + btn.dataset.path); });
    });

    document.querySelectorAll('#cita-quiz-q2-chair .cita-quiz__opt, #cita-quiz-q2-hammock .cita-quiz__opt').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var p = products[btn.dataset.result];
        if (!p) return;
        document.getElementById('cita-quiz-rname').textContent = p.name;
        document.getElementById('cita-quiz-rdesc').textContent = p.desc;
        var rbtn = document.getElementById('cita-quiz-rbtn');
        if (p.url) { rbtn.href = p.url; rbtn.style.display = ''; }
        else { rbtn.style.display = 'none'; }
        showPanel('result');
      });
    });

    document.querySelectorAll('#cita-quiz-section .cita-quiz__back').forEach(function(btn) {
      btn.addEventListener('click', function() { showPanel(btn.dataset.target); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-reviews-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cita-rv--vis');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06 });
    document.querySelectorAll(
      '.cita-rv__stat, .cita-rv__card, .cita-rv__resort-logo, .cita-rv__cta-ct, .cita-rv__write-title'
    ).forEach(function(el) {
      el.classList.add('cita-rv--fade');
      obs.observe(el);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-setup-care"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Chapter nav active state on scroll
  var sections = document.querySelectorAll('.cita-sc__chapter[id]');
  var navItems = document.querySelectorAll('.cita-sc__nav-item');
  if (sections.length && navItems.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          navItems.forEach(function(n) {
            n.classList.toggle('cita-sc__nav-item--on', n.getAttribute('href') === '#' + id);
          });
        }
      });
    }, { threshold: 0.3, rootMargin: '-80px 0px -50% 0px' });
    sections.forEach(function(s) { obs.observe(s); });
  }

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var revObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cita-sc--vis');
          revObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06 });
    document.querySelectorAll(
      '.cita-sc__step-card, .cita-sc__hang-card, .cita-sc__care-card, .cita-sc__video-wrap, .cita-sc__req-box, .cita-sc__kit-says, .cita-sc__cta-ct'
    ).forEach(function(el) {
      el.classList.add('cita-sc--fade');
      revObs.observe(el);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-shipping"] && !Shopify.designMode) return;
  try {
    
(function() {
  // FAQ accordion
  document.querySelectorAll('.cita-sh__faq-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var faq = this.closest('.cita-sh__faq');
      var isOpen = faq.classList.contains('cita-sh__faq--open');
      // close all
      document.querySelectorAll('.cita-sh__faq').forEach(function(f) {
        f.classList.remove('cita-sh__faq--open');
        f.querySelector('.cita-sh__faq-trigger').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        faq.classList.add('cita-sh__faq--open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cita-sh--vis');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06 });
    document.querySelectorAll(
      '.cita-sh__tl-card, .cita-sh__pillar, .cita-sh__step, .cita-sh__fiji-loc, .cita-sh__fiji-step, .cita-sh__cta-ct'
    ).forEach(function(el) {
      el.classList.add('cita-sh--fade');
      obs.observe(el);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cita-warranty-returns"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.cita-wr-faq-item__trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.cita-wr-faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.cita-wr-faq-item.open').forEach(function(el) {
        el.classList.remove('open');
        el.querySelector('.cita-wr-faq-item__trigger').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.cita-wr-pillar, .cita-wr-warranty-card, .cita-wr-step, .cita-wr-promise__inner, .cita-wr-signoff__ct').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      obs.observe(el);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Qty change
  document.querySelectorAll('.cita-cart-pg__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = btn.dataset.key;
      var delta = parseInt(btn.dataset.delta);
      var display = document.getElementById('qty-' + key);
      if (!display) return;
      var newQty = Math.max(0, parseInt(display.textContent) + delta);
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function() { window.location.reload(); });
    });
  });

  // Remove
  document.querySelectorAll('.cita-cart-pg__remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.textContent = 'Removing…';
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      }).then(function() { window.location.reload(); });
    });
  });

  // Order note toggle
  var noteToggle = document.getElementById('cita-note-toggle');
  var noteWrap = document.getElementById('cita-cart-note');
  if (noteToggle) {
    noteToggle.addEventListener('click', function() {
      noteWrap.classList.toggle('open');
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
